import React from 'react';
import Select from 'react-select';
import { Avatar, Box, Text, Flex } from '@chakra-ui/react';

const RentalSelect = ({ rentals, onSelect, value }) => {
    // Options fürs Select vorbereiten
    const rentalOptions = rentals.map(rental => ({
        value: rental.id,
        label: rental.title,
        avatar: rental.teaser_picture,
        original: rental,
    }));

    // Custom Option Renderer
    const CustomOption = (props) => {
        const { data, innerRef, innerProps, isFocused, isSelected } = props;
        return (
            <Box
                ref={innerRef}
                {...innerProps}
                bg={isFocused ? 'gray.100' : 'white'}
                fontWeight={isSelected ? 'bold' : 'normal'}
                p={2}
            >
                <Flex align="center">
                    <Avatar size="sm" src={data.avatar} mr={3} />
                    <Text noOfLines={1} maxWidth={250}>{data.label}</Text>
                </Flex>
            </Box>
        );
    };

    const CustomSingleValue = ({ data }) => (
        <Flex align="center">
            <Avatar size="sm" src={data.avatar} mr={3} />
            <Text noOfLines={1} maxWidth={250}>{data.label}</Text>
        </Flex>
    );

    const selectedOption = rentalOptions.find(option => option.value === value?.id);

    return (
        <Select
            options={rentalOptions}
            value={selectedOption}
            onChange={(selectedOption) => {
                onSelect(selectedOption ? selectedOption.original : null);
            }}
            components={{ Option: CustomOption, SingleValue: CustomSingleValue }}
            placeholder="Wähle eine Unterkunft..."
            isClearable
            isSearchable={false}
            styles={{
                control: (provided) => ({
                    ...provided,
                    padding: '8px',
                    borderRadius: '8px',
                    borderColor: '#E2E8F0',
                    boxShadow: 'none',
                    '&:hover': { borderColor: '#CBD5E0' },
                }),
                indicatorsContainer: provided => ({
                    ...provided,
                    cursor: 'pointer'
                }),
                valueContainer: provided => ({
                    ...provided,
                    ' input': { display: 'none' },
                    width:'300px'
                }),
                menu: provided => ({
                    ...provided,
                    zIndex: '100',
                    cursor: 'pointer'
                })
            }}
        />
    );
};

export default RentalSelect;
